import { Injectable } from '@angular/core';
import { Hyperlinks } from 'app/modules/admin/team/my-data/my-data.types';
import { SharedService } from './shared.service';
import { UserService } from './user.service';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
    providedIn: 'root',
})
export class HyperlinksService {
    hyperlinks: Hyperlinks[];
    constructor(
        private sharedService: SharedService,
        private userService: UserService,
        private httpClient: HttpClient,
        private translocoService: TranslocoService
    ) {}

    async getHyperlinks() {
        const formData = new FormData();
        formData.append(
            'tln_id',
            this.translocoService.getActiveLang() === 'de' ? '15' : '11'
        );
        formData.append('option', 'hyperlinks');
        try {
            const data = await lastValueFrom(
                this.httpClient.post<any>(
                    `hippo/ajax_navigator.php?page=pages/api/Ajax_common_lists.php&uid=${this.userService.user.uid}&page_type=json`,
                    formData,
                    {
                        observe: 'response',
                    }
                )
            );
            this.hyperlinks = JSON.parse(JSON.stringify(data.body.result));
            // workaround to trigger navigation reload
            this.translocoService.setActiveLang(
                this.translocoService.getActiveLang()
            );
        } catch (error) {
            console.log(error);
            const result = error?.error?.result;

            if (
                result === 'page access denied' ||
                result?.message === 'page access denied'
            ) {
            } else {
                this.sharedService.showDataNotLoaded(
                    error,
                    'HyperlinksService',
                    'getHyperlinks'
                );
            }
        }
    }
}
